import React from 'react';
import { StarIcon, TruckIcon, MapPinIcon, ShieldCheckIcon } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-white border-b border-gray-200 relative z-20" data-id="element-260">
      <div className="container-wide" data-id="element-261">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-100" data-id="element-262">
          {/* Free 5km Delivery — THE HERO */}
          <div className="flex items-center gap-3 py-5 px-4 md:px-6 bg-brand-green-50" data-id="element-263">
            <div className="w-12 h-12 rounded-full bg-brand-green flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-264">
              <TruckIcon className="w-6 h-6 text-white" data-id="element-265" />
            </div>
            <div data-id="element-266">
              <div className="font-heading font-extrabold text-brand-green text-sm md:text-base leading-tight" data-id="element-267">
                FREE Drop-off
              </div>
              <div className="text-xs text-gray-600 font-medium" data-id="element-268">
                Within 5km of any store*
              </div>
            </div>
          </div>

          {/* Rating */}
          <div className="flex items-center gap-3 py-5 px-4 md:px-6" data-id="element-269">
            <div className="flex text-yellow-400" data-id="element-270">
              <StarIcon className="w-5 h-5 fill-current" data-id="element-271" />
              <StarIcon className="w-5 h-5 fill-current" data-id="element-272" />
              <StarIcon className="w-5 h-5 fill-current" data-id="element-273" />
              <StarIcon className="w-5 h-5 fill-current" data-id="element-274" />
              <StarIcon className="w-5 h-5 fill-current" data-id="element-275" />
            </div>
            <div data-id="element-276">
              <div className="font-heading font-bold text-gray-900 text-sm leading-tight" data-id="element-277">
                4.6/5 Average
              </div>
              <div className="text-xs text-gray-500" data-id="element-278">Across 6 stores</div>
            </div>
          </div>

          {/* WA Owned */}
          <div className="flex items-center gap-3 py-5 px-4 md:px-6" data-id="element-279">
            <img src="https://cdn.magicpatterns.com/uploads/cHcSSRvAwPTr86uE9Kk5yi/WA_OWned.webp" alt="Western Australian Owned" className="w-10 h-10 rounded-full object-cover shadow-sm" data-id="element-280" />
            <div data-id="element-281">
              <div className="font-heading font-bold text-gray-900 text-sm leading-tight" data-id="element-282">
                100% WA Owned
              </div>
              <div className="text-xs text-gray-500" data-id="element-283">& Operated</div>
            </div>
          </div>

          {/* 6 Locations */}
          <div className="flex items-center gap-3 py-5 px-4 md:px-6" data-id="element-284">
            <div className="w-10 h-10 rounded-full bg-brand-blue-50 flex items-center justify-center flex-shrink-0" data-id="element-285">
              <MapPinIcon className="w-5 h-5 text-brand-blue" data-id="element-286" />
            </div>
            <div data-id="element-287">
              <div className="font-heading font-bold text-gray-900 text-sm leading-tight" data-id="element-288">
                6 Perth Stores
              </div>
              <div className="text-xs text-gray-500" data-id="element-289">Open 7 days</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}